<ion-card
  class="details-card"
  [ngClass]="viewModel?.notification.read ? 'read' : ''"
  *ngIf="viewModel"
>
  <ion-card-header>
    <div class="flex-title mb-6">
      <div>
        <ion-label
          [attr.data-cy]="
            'notification-details-' +
            viewModel.notification.alertBatchId +
            '-title'
          "
          [ngClass]="
            platformService.platformType === platformService.platformEnum.mobile
              ? 'mobile-notification-title'
              : 'notification-title'
          "
        >
          {{ 'i18n.notifications.ctaLinkLabels.deliveryIssues' | translate }}
        </ion-label>
      </div>
      <div class="flex-title">
        <ion-label
          [attr.data-cy]="
            'notification-details-' +
            viewModel.notification.alertBatchId +
            '-timestamp'
          "
          class="notification-subtitle bold"
        >
          {{ viewModel.notification.addDtm | date: 'MM/dd/YYYY' : 'GMT' }}
        </ion-label>
      </div>
    </div>
    <div class="flex-customer mb-8">
      <div>
        <ion-label
          [attr.data-cy]="
            'notification-details-' +
            viewModel.notification.alertBatchId +
            '-customer-name'
          "
          class="notification-subtitle"
        >
          {{ viewModel.notification.customerName | titlecase }}
        </ion-label>
      </div>
      <div>
        <ion-label
          [attr.data-cy]="
            'notification-details-' +
            viewModel.notification.alertBatchId +
            '-customer-number'
          "
          class="notification-subtitle"
        >
          (ID {{ viewModel.notification.customerNumber }})
        </ion-label>
      </div>
    </div>
  </ion-card-header>
  <ion-card-content>
    <div class="order-number">
      <ion-label
        [attr.data-cy]="
          'notification-details-' +
          viewModel.notification.alertBatchId +
          '-order-number'
        "
      >
        Order {{ viewModel.orderNumber }}
      </ion-label>
    </div>
    <ng-container
      *ngFor="let deliveryException of viewModel.deliveryExceptions"
    >
      <ion-label
        [attr.data-cy]="
          'notification-details-' +
          viewModel.notification.alertBatchId +
          '-reason-' +
          deliveryException.reasonCode
        "
        class="reason-description"
      >
        {{ deliveryException.reasonDescription }}
      </ion-label>
      <ul
        class="product-list"
        [ngClass]="
          platformService.platformType === platformService.platformEnum.mobile
            ? 'product-list-mobile'
            : ''
        "
      >
        <li
          *ngFor="let item of viewModel.deliveryExceptions"
          [attr.data-cy]="
            'notification-details-' +
            viewModel.notification.alertBatchId +
            '-reason-' +
            deliveryException.reasonCode +
            '-product-' +
            item.productNumber
          "
        >
          {{ item.productName }} ({{ item.productNumber }}) |
          {{ item.undeliveredQuantity }} {{ item.unitOfMeasure }}
        </li>
      </ul>
    </ng-container>
  </ion-card-content>
</ion-card>
<ion-row>
  <ion-col class="center">
    <ion-button
      data-cy="notification-details-btn-cta"
      fill="clear"
      class="usf-fill-green-button"
      [ngClass]="
        platformService.platformType === platformService.platformEnum.desktop
          ? 'view-my-order'
          : 'tablet-mobile-view-my-order'
      "
      (click)="navigateTo(viewModel.notification)"
    >
      <ion-label>{{ notificationMetadata.linkLabel }}</ion-label>
    </ion-button>
  </ion-col>
</ion-row>
